<template>
  <main>
    <!-- <v-data-table :headers="headers" :items="camps" hide-default-footer></v-data-table> -->
    <InputFilter class="pt-10" :pagination="pagination" />
    <v-container>
      <v-toolbar flat class="main-header mb-12">
        <v-toolbar-title class="main-header__title">
          <h1>All Parents</h1>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-toolbar-items
          v-if="permissions.includes('store_api_admin-panel_accounts')"
          class="main-header__contents"
        >
          <v-btn
            class="button btn-height--1 my-auto mx-1"
            color="primary"
            to="/accounts/create"
            rounded
          >
            <span class="mx-2">Add Account</span>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="parents"
        :loading="loadingParents"
        :mobile-breakpoint="zero"
        :items-per-page="20"
        class="table"
        hide-default-footer
      >
        <!-- hide-default-footer -->
        <template v-slot:item="{ item }">
          <tr class="table__row">
            <!-- <td class="table__cell text-center">
              <v-icon v-if="parent.item.available" class="gold-icon">
                mdi-star
              </v-icon>
              <v-icon v-else>mdi-star-outline</v-icon>
            </td> -->
            <td class="table__cell text-center">{{ item.account_no }}</td>
            <td class="table__cell text-center name">{{ item.name }}</td>
            <td class="table__cell text-center">{{ item.email }}</td>
            <td class="table__cell text-center">{{ item.mobile }}</td>
            <td class="table__cell text-center">
              {{ item.relation ? item.relation.name : "---" }}
            </td>
            <td class="table__cell text-center">
              <i v-if="item.primary === 1" class="gold-icon icon-active"></i>
              <i v-else class="icon-inactive icon-inactive"></i>
            </td>
            <td class="table__cell text-center">
              <v-chip
                v-if="!item.has_complete_profile"
                small
                color="#faddd2"
                text-color="#ec531e"
              >
                <v-icon small>mdi-close-circle</v-icon>
              </v-chip>
              <v-chip v-else small color="#dcf3d1" text-color="#82c565">
                <v-icon small>mdi-checkbox-marked-circle</v-icon>
              </v-chip>
            </td>
            <td class="table__cell text-center">
              <v-chip
                v-if="!item.has_complete_account"
                small
                color="#faddd2"
                text-color="#ec531e"
              >
                <v-icon small>mdi-close-circle</v-icon>
              </v-chip>
              <v-chip v-else small color="#dcf3d1" text-color="#82c565">
                <v-icon small>mdi-checkbox-marked-circle</v-icon>
              </v-chip>
            </td>
            <td class="table__cell text-center">
              <span
                class="hovering mr-1 edit"
                @click="accountData(item)"
                v-if="
                  permissions.includes(
                    'show_api_admin-panel_accounts_{account}'
                  )
                "
              >
                <!-- `/parents/create/${camp.item.id}` -->
                <v-icon small>mdi-eye</v-icon><br />
                Show
              </span>
              <span v-else>---</span>
            </td>
          </tr>
        </template>
      </v-data-table>

      <!-- pagination -->
      <div class="text-xs-center pt-2">
        <v-pagination
          v-if="parents.length > 0 && pagination.last_page > 1"
          v-model="pagination.current_page"
          :length="pagination.last_page"
          :total-visible="20"
          @input="handlePagination"
        ></v-pagination>
      </div>
      <!-- pagination -->
    </v-container>
  </main>
</template>

<script>
import { IndexData } from "@/helpers/apiMethods";
import TableHeaders from "@/helpers/TableHeaders";
import { isEqual } from "lodash";
import { mapGetters } from "vuex";
// import convertQuery from "../../utils/buildQuery";
// import convertQuery from "../../utils/buildQuery";

export default {
  data() {
    return {
      zero: 0,
      headers: [],
      parents: [],
      pagination: {},
      queries: {},
      search: null,
      loadingParents: false
    };
  },
  components: {
    InputFilter: () => import("./components/InputFilter")
  },
  computed: {
    ...mapGetters({
      permissions: "permissions"
    })
  },
  created() {
    this.parentsHeaders();
  },
  methods: {
    indexparents(query) {
      this.loadingParents = true;

      // let convertedQuery = {};
      // if (query.search) {
      //   convertedQuery = { search: encodeURIComponent(query.search) };
      // }
      // console.log(convertedQuery.search);
      // convertedQuery = { ...convertedQuery, ...this.$route.query };
      IndexData({ reqName: "parents", query })
        .then(res => {
          const { data, meta } = res.data;
          this.parents = data;
          this.loadingParents = false;
          this.pagination = meta;
        })
        .catch(() => {})
        .finally(() => {});
    },
    parentsHeaders() {
      const headersList = [
        "Accont No",
        "Name",
        "Email",
        "Mobile",
        "Relation",
        "Primary",
        "Complete Profile",
        "Complete Account",
        "Actions"
      ];
      this.headers = TableHeaders(headersList);
    },
    createCamp() {
      this.$route.push("/parents/create");
    },
    handlePagination(page) {
      this.queries = { ...this.$route.query, page };
      if (!isEqual(this.queries, this.$route.query)) {
        this.$router.push({ query: this.queries });
      }
    },
    accountData(item) {
      this.search = item;
      this.$router.push({
        path: "accounts/parents",
        query: { search: item.account_no, account: item.account_id }
      });
    }
  },
  watch: {
    $route: {
      handler({ query }) {
        // this.queries = { ...this.queries, ...query };
        this.pagination.current_page = query.page;
        let decodedQuery = {};
        for (const key in query) {
          decodedQuery[key] = encodeURIComponent(query[key]);
        }

        this.indexparents(decodedQuery);
      },
      immediate: true
    }
  }
};
</script>
